import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { notificationApi } from '@/services/notifications/notifications'
import { useAuth } from '@/hooks/useAuth'

// Get paginated notifications with infinite scroll
export const useNotifications = () => {
  const { isAuthenticated } = useAuth()

  return useInfiniteQuery({
    queryKey: ['notifications'],
    queryFn: ({ pageParam = 1 }) => notificationApi.getNotifications(pageParam, 20),
    getNextPageParam: (lastPage) => {
      const hasMore = lastPage.page < lastPage.totalPages
      return hasMore ? lastPage.page + 1 : undefined
    },
    initialPageParam: 1,
    staleTime: 30000, // 30 seconds
    enabled: isAuthenticated, // Only fetch when authenticated
  })
}

// Get unread count
export const useUnreadCount = () => {
  const { isAuthenticated } = useAuth()

  return useQuery({
    queryKey: ['notifications', 'unreadCount'],
    queryFn: () => notificationApi.getUnreadCount(),
    staleTime: 30000, // 30 seconds
    refetchInterval: 60000, // Refetch every minute
    enabled: isAuthenticated, // Only fetch when authenticated
  })
}
